import React from "react";

// Small lantern mark — nods to "Nuru" (light in Swahili)
const Lantern = ({ size = 18, className = "", glow = false, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* hanging loop */}
    <path d="M12 2v2" />
    {/* top cap */}
    <path d="M7 5h10" />
    {/* lantern body */}
    <path d="M8 6c-1 1.5-1.5 3.2-1.5 5.5C6.5 15 8.5 17.5 12 17.5s5.5-2.5 5.5-6c0-2.3-.5-4-1.5-5.5Z" />
    {/* base */}
    <path d="M9 18.5h6" />
    <path d="M10 20.5h4" />
    {/* inner flame */}
    {glow ? (
      <path className="lantern-flame" d="M12 9.5c-1 1.2-1.5 2.2-1.5 3.2 0 1 .7 1.8 1.5 1.8s1.5-.8 1.5-1.8c0-1-.5-2-1.5-3.2Z" fill="#FBBF24" stroke="#FBBF24" />
    ) : (
      <path d="M12 9.5c-.8 1-1.2 1.8-1.2 2.7 0 .8.5 1.5 1.2 1.5s1.2-.7 1.2-1.5c0-.9-.4-1.7-1.2-2.7Z" />
    )}
  </svg>
);

export default Lantern;
